export default __webpack_public_path__ + "static/media/bandeira_amarela.3a2254d3.svg";